module.exports = __webpack_public_path__ + "static/image/history/pc/201012@3x.jpg?f3f28993";